<template>
  <div>
    <el-alert title="注意事项" :closable="false">
      <p>· 所有账期的应收金额累加，不能超过按上一步配置生成的应收总金额上限；</p>
      <p>· 付款方式为月付时，不足月的账期按上一步配置自动生成，可手动编辑修改；</p>
      <p>· 若删除某个账期，其他账期的起止日等信息不变，请注意调整并确认。</p>
    </el-alert>
    <div class="total">
      <div class="totalItem">
        <span class="totalItemLable">收款起止日期：</span>
        <span class="totalItemValue">{{`${configData.formData.startTime && configData.formData.startTime.split(' ')[0] || ''} 至 ${configData.formData.endTime && configData.formData.endTime.split(' ')[0] || ''}`}}</span>
      </div>
      <div class="totalItem">
        <span class="totalItemLable">应收总金额上限：</span>
        <span class="totalItemValue">
          {{`${floatFormat(formatNumberWithCommas(configData.formData.receivableTotalAmount))}元（`}}
          <span :class="{'err': amountRules}">{{`账单累计总金额${floatFormat(formatNumberWithCommas(billTotalAmount))}元`}}<span v-if="amountRules">，已超限</span></span>）
        </span>
      </div>
      <div class="totalItem">
        <span class="totalItemLable">应收账单总期数：</span>
        <span class="totalItemValue">{{tableDataFrom.tableData.length}}期</span>
        <el-button v-if="configData.formData.payMode !== PAYMODE_CODE_MAP.DISPOSABLE" @click="addButton" class="addButton" type="minor" size="mini">+ 新增期数</el-button>
      </div>
    </div>
    <!-- src/components/PaymentPlanPopup/index.vue有引用 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form ref="otherPayFrom" :model="tableDataFrom" >
      <el-table
        class="add-table"
        :data="tableDataFrom.tableData"
        style="width: 100%"
        row-key="num"
        max-height="242"
      >
        <el-table-column align="center" label="期数" width="48" prop="num">
        </el-table-column>
        <el-table-column align="left" :label="`收款类型`" width="76">
          <template>
            <el-form-item>
              <span>{{ getFreeTypeName(configData.fundType) }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="left" width="170" :label="`应收金额`">
          <template slot-scope="scope">
            <el-form-item
              :prop="`tableData.${scope.$index}.planAmount`"
              :rules="rules.payAmount"
            >
              <span v-if="configData.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE">{{scope.row.planAmount}}</span>
              <el-input
                v-else
                placeholder="请输入金额"
                v-model="scope.row.planAmount"
                @input="(val) => priceChange(val, scope.$index)"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column width="250" prop="payItem" align="left" label="款项周期">
          <template slot-scope="scope">
            <el-form-item :rules="rules.accruedCycle" :prop="`tableData.${scope.$index}.accruedCycle`">
              <span v-if="configData.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE">一次性</span>
              <el-date-picker
                v-else
                v-model="scope.row.accruedCycle"
                type="daterange"
                :clearable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column width="136" align="left" :label="'缴款日'">
          <template slot-scope="scope">
            <el-form-item :rules="rules.dueDate" :prop="`tableData.${scope.$index}.dueDate`">
              <span v-if="configData.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE">{{scope.row.dueDate}}</span>
              <el-date-picker
                v-else
                class="dueDate"
                :clearable="false"
                v-model="scope.row.dueDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="left" label="备注" width="200">
          <template slot-scope="scope">
            <el-form-item
              :prop="`tableData.${scope.$index}.remarks`"
            >
              <el-input
                maxlength="500"
                placeholder="请输入备注"
                v-model="scope.row.remarks"
              >
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-popover
              :ref="scope.$index"
              v-if="isShowDeleteBtn"
              placement="bottom"
              width="230"
              popper-class="delete-order"
            >
              <p>确定删除该账期吗?</p>
              <div class="delete-order-btns" style="text-align: right; margin: 0">
                <el-button size="mini" class="cancel-btn" @click="cancel"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    cancel()
                    handleDel(scope.$index)
                  "
                  >确定</el-button
                >
              </div>
              <el-button type="text" slot="reference">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import { PAYMODE_CODE_MAP } from '@/store/dict/rentPlanDict'
import { formatNumberWithCommas } from '@/utils'
import { limitMoreZero } from '@/utils/validate'
import { mapState } from 'vuex'
import { numberUtils } from '@/utils/number'

export default {
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      PAYMODE_CODE_MAP,
      rules: {
        payAmount: [
          { required: true, message: '金额不能为空', trigger: 'change' },
        ],
        accruedCycle: [
          { required: true, message: '款项周期不能为空', trigger: 'change' },
        ],
        dueDate: [
          { required: true, message: '缴款日不能为空', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      rentOrderFeeList: (state) => state.global.rentOrderFeeList,
    }),
    // 汇总
    billTotalAmount() {
      const { amountAccuracy } = this.configData.formData
      const total = this.tableDataFrom.tableData.reduce((prev, cur) => {
        return numberUtils.plus(prev, Number(cur.planAmount))
      }, 0)
      if (amountAccuracy === 2) {
        return total.toFixed(2)
      }
      return total
    },
    isShowDeleteBtn() {
      return this.tableDataFrom.tableData.length > 1
    },
    amountRules() {
      return Number(this.configData.formData.receivableTotalAmount) < Number(this.billTotalAmount)
    },
  },
  methods: {
    formatNumberWithCommas,
    floatFormat(val) {
      const { amountAccuracy } = this.configData.formData
      if (amountAccuracy === 0) {
        return val
      } else {
        const arr = val.split('.')
        if (arr.length === 1) {
          return `${val}.00`
        } else if (arr[1].length === 1) {
          return `${val}0`
        }
        return val
      }
    },
    // 获取收款类型名称
    getFreeTypeName(type) {
      return this.rentOrderFeeList.find((item) => item.code === type).name
    },
    // 监听金额变化
    priceChange(value, index) {
      limitMoreZero(value, (v) => {
        this.$set(this.tableDataFrom.tableData[index], 'planAmount', v)
      }, 9)
    },
    // popper弹框取消
    cancel() {
      document.body.click()
    },
    // 删除条目
    handleDel(type) {
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData.splice(type, 1)
      this.generateNum()
    },
    // 生成期数
    generateNum() {
      this.tableDataFrom.tableData.forEach((item, index) => {
        item.num = index + 1
      })
    },
    // 新增
    addButton() {
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData.push({
        planAmount: '',
        startCycleDate: '',
        endCycleDate: '',
        dueDate: '',
        accruedCycle: '',
      })
      this.generateNum()
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {},
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
.add-table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 22px;
}
.add-table ::v-deep td {
  padding: 0 !important;
}
.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
::v-deep .el-alert__title {
  color: #276BEC;
}
::v-deep .el-alert__description {
  color: #303133;
  font-weight: 500;
}
.err {
  color: red;
}
.dueDate {
  width: 124px;
}
.total {
  margin-top: 10px;
  .totalItem {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .totalItemLable {
      display: block;
      width: 112px;
      text-align: right;
    }
    .totalItemValue {
      font-weight: 500;
    }
    .addButton {
      margin-left: 10px;
    }
  }
}
</style>
